import { Injectable, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { UserLoggedInService } from './services/angular/UserLoggedIn';
import { ToastrService } from 'ngx-toastr';
import { CryptoJs } from './shared/crypto-js/crypto-js.component';
import { isNull, isUndefined } from 'util';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentEnum } from './core/enums/environment-enum';
import { environment } from 'environments/environment';
 
@Injectable()
export class Globals implements OnChanges {

    public passString = '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*';
    public lpassString = '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*' 

    admin = false;
    coach = false;
    client = false;
    rater = false;
    selectedMode: string;
    isLoggedIn = false;

    previewModeJSON: any;
    previewAssessmentId: number;
    currentEditingAssessment: any;
    regularDeleted: any[];
    satisfactionDeleted: any[];
    surveyDeleted: any[];
    section1Deleted: any[];
    section2Deleted: any[];
    showAssessment360: boolean;

    unassignedAssessmentGridApi: any;
    assignedAssessmentGridApi: any;
    completedAssessmentGridApi: any;
    expiredAssessmentGridApi: any;

    gridApis: any[] = [];
    // userId: number = 0;

    // sidebar menu
    sidebarVisible = false;
    toggleButton: any;
    toggleMenuWithOutLoggin = false;

    // rater take assessment
    raterAssessmentId: number;
    raterEmail: string;
    raterAssignedAssessment: number;
    raterAssessmentName: string;

    // client or rater taking the assessment from invitation link
    invitationLinkFrom = '';
    invitationLinkUserId: number;
    invitationLinkUserEmail: string;
    invitationLinkUserName: string;
    invitationLinkUserLastName: string;
    invitationLinkAssessmentId: number;
    invitationLinkAssessmentName: string;
    invitationLinkAssignmentId: number;
    invitationLinkLanguage: string;
    invitationLinkFullName: string;
    isClientTakeAssessment = false;
    invitacionLinkCompareIds = false;

    // COACH SEEING REULTS \\ ASSESSMENT-DETAILS link
    isCoachSeeingResults = false;
    aResultCoachId: number;
    aResultUserType: string;

    // unassigned assessment // Coach mode
    // unassignedAssessments = [];
    availableAsessmentsRegular = [];
    availableAsessments360 = [];

    // assigned // coach mode
    assignedUserId: number;
    assignedRegularData = []
    assigned360Data = [];
    assignedAssessmentType = 1.1;
    assignedCanDelete = false;
    assignedCanCopy = false;
    assignedCanAddRaters = false;
    assignedCanUpdate = false;
    assignedCanSend = false;
    assignedCanSendReminder = false;
    assignedCanConversionRate = false;
    assignedCanAddTags = false;

    // completed assessment // coach mode
    completedUserId: number;
    completedRegularData = [];
    completed360Data = [];
    completedCanEnableResults = false;
    completedCanArchiveAssessments = false;
    completedCanAddTags = false;

    // expired // coach mode
    expiredUserId: number;
    expiredRegularData = [];
    expired360Data = [];
    expiredAssessmentType = 3.1;
    expiredCanDelete = false;
    expiredCanCopy = false;
    expiredCanAddRaters = false;
    expiredCanExtend = false;
    expiredCanSend = false;
    expiredCanSendReminder = false;
    expiredCanAddTags = false;

    // purchase from home page
    purchaseFromHome = false;
    assessmentsTypeFlag: number;

    showCompletedAssessments = false;

    closeHomeAssignModal = false;
    refreshTableOnAssessmentsResults = false;

    userEmail = '';

    // not activate account from login
    clientOrRaterEmailFromLogin: string;
    clientOrRaterNameFromLogin: string;
    clientOrRaterLastFromLogin: string;

    // regular
    boolGetAllQuestions = false;

    // logged out page
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    title = 'angular-idle-timeout';

    // coach results
    coachResultsDisplayToast = false;

    // activate account user assessment link
    activateAccountAssessmentData = '';

    loadPageContentClientResults = false;
    assesmentErrorMessage = '';

    instructionsPageContent: string;
    thankyouPageContent: string;
    pagesArr: any[] = [];
    previewMode = false;
    assessmentCompleted = false;
    assignAssessmentsForImportClients = false;
    importedClients: any[] = [];
    base64ImportFile = '';
    fileInputEvent: any;

    // useProductionUrl = true;
    serviceUrl = environment.serviceUrl;

    managerAvailableRoutes: any[] = ['admin_dashboard', 'announcements', 'users', 'assessments_mod_lll', 'user_personal_data/:id'];

    // restore assessments
    canRestoreAssessments = false;
    archivedAssessmentGridApi: any;
    showArchivedAssessments = false;
    archived360Data = [];
    archivedRegularData = [];

/*    version = "1.0";*/

    constructor(
        private router: Router,
        public idle: Idle,
        // public keepalive: Keepalive,
        private _UserLoggedInService: UserLoggedInService,
        public _Toastr: ToastrService,
        private httpClient: HttpClient,
        public _CryptoJs: CryptoJs
    ) {

        // this.setServicesUrl();
        // console.log('CONSTRUCTOR');
        // sets an idle timeout of 5 seconds, for testing purposes.
        idle.setIdle(3570);
        // idle.setIdle(10);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(30);
        // idle.setTimeout(5);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() => {
            this.idleState = 'No longer idle.'
            console.log(this.idleState);
            this.reset();
        });

        idle.onTimeout.subscribe(() => {
            this.idleState = 'Timed out!';
            this.timedOut = true;
            console.log(this.idleState + ' inactivity Logout');
            this.inactivityLogout();
        });

        idle.onIdleStart.subscribe(() => {
            this.idleState = 'You\'ve gone idle!'
            console.log(this.idleState);
        });

        idle.onTimeoutWarning.subscribe((countdown) => {
            this.idleState = 'You will time out in ' + countdown + ' seconds!'
            console.log(this.idleState);
        });

        // sets the ping interval to 15 seconds
        // keepalive.interval(15);

        // keepalive.onPing.subscribe(() => {
        //    console.log('keepalive');
        //    this.lastPing = new Date()
        // });

        // this._UserLoggedInService.getUserLoggedIn().subscribe(userLoggedIn => {
        console.log('userLoggedIn', this.userLoggedIn());
        if (this.userLoggedIn()) {
            idle.watch()
            this.timedOut = false;
        } else {
            idle.stop();
        }
        // })

        // this.reset();
        console.log('get available modes', this.getAvailableModes());
        console.log('userHasSpecificMode', this.userHasSpecificMode('Administrator'));
        this.hideChatBotForClients();
    }

    ngOnChanges() {
        console.log('ngOnChanges');
    }

    getActiveMode() {
        return $('#customSelectId').val();
    }

    hideChatBotForClients() {

        setTimeout(() => {
            const activeMode = this.getActiveMode();
            let userIsClient = false;
            if (isUndefined(activeMode)) {
                userIsClient = this.userHasSpecificMode('Client');
            }

            if (String(activeMode) === 'Client' || userIsClient) {
                console.log('hide ChatBot For Clients');
                $('#hubspot-messages-iframe-container').css({
                    'opacity': '0',
                    'pointer-events': 'none'
                });
                // $('.navbar-right-menu').css({
                //    'opacity': '0.5',
                //    'pointer-events': 'all'
                // });
            } else {
                console.log('show ChatBot');
                $('#hubspot-messages-iframe-container').css({
                    'opacity': '1',
                    'pointer-events': 'all'
                });
                // $('.navbar-right-menu').css({
                //    'opacity': '1',
                //    'pointer-events': 'all'
                // });
            }
        }, 1000);
    }

    reset() {
        this.idle.watch();
        // xthis.idleState = 'Started.';
        this.timedOut = false;
    }

    stay() {
        this.reset();
    }

    stopIdle() {
        this.idle.stop();
    }

    inactivityLogout() {
        this.deleteAllStorage();
        this.router.navigate(['/LOGGEDOUT']);
        console.log('inactivity Logout');
    }

    deactivateAllModes() {
        this.admin = false;
        this.coach = false;
        this.client = false;
        this.rater = false;
    }

    userLoggedIn(): boolean {
        let token = localStorage.getItem('DXZ6cN8WJS');
        if (token === null) { token = ''; }
        // console.log('userLoggedIn');
        // console.log('DXZ6cN8WJS', token);
        if (token) {
            this.isLoggedIn = true;
            return true;
        } else {
            this.isLoggedIn = false;
            return false;
        }
    }

    setToken(token: string) {
        localStorage.setItem('DXZ6cN8WJS', token);
    }

    getToken(): string {
        let token = localStorage.getItem('DXZ6cN8WJS');
        if (token === null) { token = ''; }
        // console.log('DXZ6cN8WJS', token);
        if (token) {
            this.userLoggedIn();
        }
        return token;
    }

    setMode(mode: string) {
        localStorage.setItem('kUvPfGbd6J', mode);
    }

    getMode(): string {
        let mode = localStorage.getItem('kUvPfGbd6J');

        if(mode != "" && mode != null){
            //Decrypt
            mode = this._CryptoJs.decrypt(mode, this.passString);
            // console.log("_mode", mode);
        }
        // console.log('kUvPfGbd6J', mode);
        return mode;
    }

    setEnvironment(environment: EnvironmentEnum) {
        localStorage.setItem('fDISWvalw6', environment.toString());
    }

    getEnvironment(): EnvironmentEnum {
        let environment = localStorage.getItem('fDISWvalw6');

        if (environment != null) {
            environment = this._CryptoJs.decrypt(environment, this.passString);
        } else {
            environment = null;
        }
        //console.log("environment", environment);

        let selectedEnvironment = environment == "Beta" ? EnvironmentEnum.Beta : environment == "Production" ? EnvironmentEnum.Production : null;

        return selectedEnvironment;
    }

    setFullName(firstName: string, lastName: string) {
        let fullname = this._CryptoJs.encrypt(this._CryptoJs.decrypt(firstName, this.passString) + " " + this._CryptoJs.decrypt(lastName, this.passString), this.passString);
        localStorage.setItem('khQo9S90Ue', fullname);
    }

    getFullName() {
        let fullName = localStorage.getItem('khQo9S90Ue');
        fullName = this._CryptoJs.decrypt(fullName, this.passString);
        // console.log('khQo9S90Ue', fullName);
        return fullName;
    }

    deleteAllStorage() {
        localStorage.removeItem('DXZ6cN8WJS');
        localStorage.removeItem('kUvPfGbd6J');
        localStorage.removeItem('khQo9S90Ue');
        localStorage.removeItem('OepbCPnScZ');
        localStorage.removeItem('v31Ng7c6zu');
        localStorage.removeItem('L8xxJlbW63');
        localStorage.removeItem('routers');
        localStorage.removeItem('tfrYcyvSqQ');
        localStorage.removeItem('OFYN11gft6');
        localStorage.removeItem('ELINR9');
        localStorage.removeItem('ELIResponseError');
        localStorage.removeItem('mp1TTMDbLn');
        localStorage.removeItem('6zNjHUJe4f');
        localStorage.removeItem('fDISWvalw6');
        localStorage.removeItem('ELIEntraUser'); 
        localStorage.removeItem('i908dOBEVP');
        this.stopIdle();
    }

    setUserId(userId: any) {
        localStorage.setItem('OepbCPnScZ', userId);
    }

    getUserId(): number {
        let userIdItem = localStorage.getItem('OepbCPnScZ');
        let userId;

        if (userIdItem != null) {
            userId = parseInt(this._CryptoJs.decrypt(userIdItem, this.passString), 10);
        }

        if (!this.invitacionLinkCompareIds) {
            if (isNaN(userId)) {

                this._Toastr.error('We are sorry. An unexpected error happened and we have to close the current session. This may be related to an incompatibility issue with your browser. Please login in an try again. If the problem persists please try with another browser or an up to date version of your current browser.', 'ELI', {
                    disableTimeOut: true
                });

                const data = {
                    'he3': 0,
                    'bo7': 'Angular.GetUserId',
                    'pm5': 'UserId is NaN',
                    'my6': this.getUserEmail() + ',' + encodeURIComponent(window.navigator.userAgent)
                }

                this.clearAllAndRediretToLogin();

                this.postSaveAtLog(
                    this._CryptoJs.encrypt(JSON.stringify(data),
                    '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*')
                    ).subscribe((_data: any) => {
                    console.log('response_postSaveAtLog', _data);
                    this.validationToken(_data.result.Result);
                });
                return;
            } else {
                return userId;
            }
        } else {
            return userId;
        }

        // console.log('OepbCPnScZ', userId);
    }

    setUserEmail(userEmail) {
        localStorage.setItem('L8xxJlbW63', userEmail);
    }

    getUserEmail(): string {
        let userEmail = localStorage.getItem('L8xxJlbW63');
        userEmail = this._CryptoJs.decrypt(userEmail, this.passString);
        // console.log('OepbCPnScZ', userId);
        if (isNull(userEmail)) { userEmail = ''; } else { return userEmail; }
    }

    validationToken(result: number): boolean {
        if (result <= -10) {
            // this.toastr.warning('Expired token please login again.', 'ELI');
            console.error('validation token error: ' + result);
            this.router.navigate(['/login']);
            this.deleteAllStorage();
            $('body').css('cursor', 'default');
            return false;
        }
        return true;
    }

    //LOGOUT
    clearAllAndRediretToLogin() {
        console.log('redirecting to login...');

        if (this.getIsEntraUser() == 1)
        {
            $('body').css('cursor', 'wait');
            $('.btn').prop('disabled', true);

            this.logOutFromAzure(this.getUserEmail()).subscribe((response: any) => {
                console.log("logOutFromAzure response", response);

                $('body').css('cursor', 'default');
                $('.btn').prop('disabled', false);

                if (response.result == 1 && response.message == "True") {
                    this.logOut();
                }
                else {
                    this._Toastr.warning("We're sorry.When we tried to log you out, something went wrong.", 'ELI');
                }
            });
        } else {
            this.logOut();
        }
    }

    logOut() {
        this.deleteAllStorage();
        this.deactivateAllModes();
        this.invitationLinkFrom = '';
        this.router.navigate(['/login']);
    }

    setAvailableModes(availableModes: string) {
        localStorage.setItem('v31Ng7c6zu', availableModes);
    }

    getAvailableModes() {
        let availableModes = localStorage.getItem('v31Ng7c6zu');
        if (availableModes == null) { availableModes = ""; }
        // console.log('OepbCPnScZ', userId);

        //Decrypt
        let _data = this._CryptoJs.decrypt(availableModes, this.passString);
        // console.log("_data", _data);
        const modes = _data.split(',');

        return modes;
    }

    setUserType(userType: string) {
        userType = this._CryptoJs.encrypt(userType, this.passString);
        localStorage.setItem('mp1TTMDbLn', userType);
    }

    getUserType() {
        let userType = localStorage.getItem('mp1TTMDbLn');
        return this._CryptoJs.decrypt(userType, this.passString);
    }

    userHasSpecificMode(mode) {
        let availableModes: string[] = this.getAvailableModes();
        if (availableModes == null) { availableModes = []; }
        if (availableModes.indexOf(mode) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    setRouterUrls(pathName: string, url: string) {
        const routers = {};
        routers[pathName] = url;
        localStorage.setItem('routers', JSON.stringify(routers));
    }

    getRouterUrls(pathName: any) {
        const routers = JSON.parse(localStorage.getItem('routers'));
        console.log('routers', routers);
        return routers[pathName];
    }

    navigate(pathName: any) {
        console.log(this.getRouterUrls(pathName));
        this.router.navigate([this.getRouterUrls(pathName)]);
    }

    setAnnouncementsStatus(status: boolean) {
        let s = this._CryptoJs.encrypt(status.toString(), this.passString);
        localStorage.setItem('tfrYcyvSqQ', s);
    }

    getAnnouncementsStatus(): string {
        const status = localStorage.getItem('tfrYcyvSqQ');
        return this._CryptoJs.decrypt(status, this.passString);
    }

    setCanUserEditEmail(status: boolean) {
        let s = this._CryptoJs.encrypt(status.toString(), this.passString);
        localStorage.setItem('OFYN11gft6', s);
    }

    getCanUserEditEmail(): string {
        const status = localStorage.getItem('OFYN11gft6');
        return this._CryptoJs.decrypt(status, this.passString);
    }

    // setServicesUrl() {
    //     if (this.useProductionUrl) {
    //         this.serviceUrl = 'https://eli-services.softcial.net/';

    //     } else {
    //          this.serviceUrl = 'https://eli-clients-eli-staging-services.azurewebsites.net/'; // staging
    //          //this.serviceUrl = 'https://eli-dev-services.azurewebsites.net/'; // Dev
    //          //this.serviceUrl = 'https://eli-beta-services.azurewebsites.net'; //Beta
    //     }
    // }

    setIsUserStudent(status: boolean) {
        let nr9: any;
        if (status) {
            nr9 = 'h64sDyw4Tn';
        } else {
            nr9 = this.generateRandomString(11);
        }

        localStorage.setItem('ELINR9', nr9);
    }

    getIsUserStudent(): string {
        return localStorage.getItem('ELINR9');
    }

    generateRandomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    // AdminService.svc/SP9
    public postSaveAtLog(encriptedData: string): Observable<any> {
        const url = `${this.serviceUrl}AdminService.svc/SP9`;

        let body: any = {
            'bw2': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postSaveAtLog body: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    allowOnlyNumberAndLetters(event: any) {
        return (
            event.charCode >= 65 && event.charCode <= 90) ||
            (event.charCode >= 97 && event.charCode <= 122) ||
            (event.charCode >= 48 && event.charCode <= 57);
    }

    loginModeredirection(mode: string) {
        this.admin = false;
        this.coach = false;
        this.client = false;

        switch (mode) {
            case 'Administrator':
            case 'Manager':
                if (this.getUserType() === 'manager') {
                    this.router.navigate(['/app/admin_dashboard']);
                } else {
                    this.router.navigate(['/app/admin_dashboard']);
                }

                this.admin = true;
                this.selectedMode = 'admin';
                break;

            case 'Coach':
                this.router.navigate(['/app/coach_home']);
                this.coach = true;
                this.selectedMode = 'coach';
                break;

            case 'Client':
            case 'Rater':
                this.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['/app/client_assessments']);
                this.client = true;
                this.selectedMode = 'client';
                break;
        }

        this.userLoggedIn();
        $('body').css('cursor', 'default');
        $('.btn').prop('disabled', true);
    }

    public setBetaAccess(hasAccess: string): void {
        localStorage.setItem('z6NjHUJe4f', hasAccess);
    }

    public hasBetaAccess(): boolean {
        let betaAccess = localStorage.getItem('z6NjHUJe4f');
        let _data = "false";
        if (betaAccess != null) {
            _data = this._CryptoJs.decrypt(betaAccess, this.passString);
        }
        return _data.toLowerCase() === "true";
    }

    //public getVersion():string {
    //    return this.version;
    //}

    public logOutFromAzure(email: string): Observable<any> {
        let url = environment.ELISSO;

        let body: any = {
            "email": email
        }

        body = JSON.stringify(body);
        console.log('logOutFromAzure body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    setIsEntraUser(isEntraUser: string) {
        localStorage.setItem('i908dOBEVP', isEntraUser);
    }

    getIsEntraUser(): EnvironmentEnum {
        let d = localStorage.getItem('i908dOBEVP');
        if (d != null) {
            let _data = this._CryptoJs.decrypt(d, this.passString);
            return (_data.toLowerCase() === "true") ? EnvironmentEnum.Beta : EnvironmentEnum.Production;
        } else {
            return EnvironmentEnum.Production;
        }        
    }

}
